import React, { useState, useEffect } from "react";
import {
  Typography,
  IconButton,
  // @ts-ignore
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  // @ts-ignore
  InputLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  CircularProgress,
  Chip,
  Divider,
  Grid,
  Avatar,
  Tooltip,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import SendIcon from "@mui/icons-material/Send";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import PaymentIcon from "@mui/icons-material/Payment";
// @ts-ignore
import SecurityIcon from "@mui/icons-material/Security";
import InfoIcon from "@mui/icons-material/Info";
// @ts-ignore
import { initiateTransfer, processTransfer } from "./apiPayment";
// @ts-ignore
import { getWallets } from "./apiWallets";
import Preloader from "./components/Preloader";
import {
  useBankTransfer,
  useVerifyWalletAccount,
  useWalletTransfer,
} from "./api/hooks/usePayment";
import { useWallet } from "./api/hooks/useWallet";
import { TaskAlt } from "@mui/icons-material";
import CustomButton from "./components/customButton";
// @ts-ignore
import CustomInput from "./components/customInput";
import { useNavigate } from "react-router-dom";

export default function WalletTransfer() {
  const [wallets, setWallets] = useState([]);
  // @ts-ignore
  const [error, setError] = useState("");

  // Form states
  const [selectedWallet, setSelectedWallet] = useState("");
  const [selectedBank, setSelectedBank] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [accountName, setAccountName] = useState("");
  const [amount, setAmount] = useState("");
  const [description, setDescription] = useState("");
  const [transactionPin, setTransactionPin] = useState("");
  const [showPin, setShowPin] = useState(false);

  const [formData, setFormData] = useState({
    source_wallet_number: "",
    destination_account_number: "",
    amount: "",
    description: "",
    transaction_pin: "",
  });

  // Transfer states
  const [transferStep, setTransferStep] = useState(1); // 1: details, 2: confirm, 3: pin
  const [transferLoading, setTransferLoading] = useState(false);
  const [transferError, setTransferError] = useState("");
  const [transferResult, setTransferResult] = useState(null);
  const [verificationError, setVerificationError] = useState("");
  const navigate = useNavigate();

  // Dialog states
  const [transferDialogOpen, setTransferDialogOpen] = useState(false);
  // @ts-ignore
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

  const { isLoading: isWalletLoading, data: walletsData } = useWallet();

  // @ts-ignore
  const walletTransferMutation = useWalletTransfer();

  const handleChange = async (e) => {
    e.preventDefault();

    const { name, value } = e.target;

    if (name == undefined) {
      const mywallet = wallets.find((element) => element.wallet_number == value);
      console.log(mywallet);

      setSelectedWallet(value);
    }

    if (name == "destination_account_number") {
      console.log(value, "length is:" + value.length);
      setFormData({ ...formData, [name]: value });

      if (value.length == 10) {
        const { data, error } = await verifyAccount();
        console.log(data, "The main data");

        if (error) {
          setVerificationError("Verification failed. Please try again.");
        } else if (data?.status) {

          setAccountName(data.data?.wallet_name);
        } else {
          setVerificationError(data?.message || "Account verification failed");
        }
      }
      return;
    }


    setFormData({ ...formData, [name]: value });
  };

  const {
    // @ts-ignore
    data: accountVerifyData,
    isFetching: isAccountVerifying,
    // @ts-ignore
    error: accountVerifyError,
    refetch: verifyAccount,
  } = useVerifyWalletAccount(formData.destination_account_number);

  // @ts-ignore
  let user = null;
  try {
    user = JSON.parse(localStorage.getItem("user"));
  } catch { }


  useEffect(() => {
    if (!walletsData) return;

    if (walletsData.data?.length > 0 || walletsData.data?.length > 0) {
      let walletsArr = walletsData?.data || [];

      walletsArr = walletsArr.filter((wallet) => wallet.currency.code == "NGN");

      setWallets(walletsArr);

      setSelectedWallet(
        walletsArr[0]?.wallet_number || walletsArr[0]?.id || ""
      );
    }

  }, [walletsData]);

  const handleInitiateTransfer = async () => {
    if (
      !selectedWallet ||
      !selectedBank ||
      !accountNumber ||
      !amount ||
      !description
    ) {
      setTransferError("Please fill in all required fields");
      return;
    }

    try {
      setTransferLoading(true);
      setTransferError("");

      const result = await initiateTransfer({
        source_wallet_number: selectedWallet,
        destination_account_number: accountNumber,
        bank_id: selectedBank,
        amount: parseFloat(amount),
        description,
      });

      if (result.status) {
        setTransferResult(result.data);
        setTransferStep(2);
      } else {
        setTransferError(result.message || "Transfer initiation failed");
      }
    } catch (error) {
      setTransferError("Transfer initiation failed. Please try again.");
      console.error("Transfer initiation error:", error);
    } finally {
      setTransferLoading(false);
    }
  };

  const handleProcessTransfer = async () => {
    if (!formData.transaction_pin) {
      setTransferError("Please enter your transaction PIN");
      return;
    }

    setTransferLoading(true);
    setTransferError("");

    const payload = {
      source_wallet_number: selectedWallet,
      destination_wallet_number: formData.destination_account_number,
      amount: parseFloat(formData.amount),
      description: formData.description,
      transaction_pin: parseInt(formData.transaction_pin),
    };

    walletTransferMutation.mutate(payload);
  };

  useEffect(() => {
    if (!walletTransferMutation.data) return;

    console.log(walletTransferMutation.data, "bank transfer thing");


    if (walletTransferMutation.data.status) {
      // setTransferResult(walletTransferMutation.data);
      console.log(walletTransferMutation.data, "This is the main thing");
      console.log(walletTransferMutation.data.data.message, "This is the main thing");

      navigate("/success-page", { state: { title: "Transaction Successful", message: walletTransferMutation.data.data.message } })

    } else {
      setTransferError(
        walletTransferMutation.data.message || "Transfer processing failed"
      );
    }
  }, [walletTransferMutation.data]);

  const handleCloseTransferDialog = () => {
    setTransferDialogOpen(false);
    setTransferStep(1);
    setTransferError("");
    setTransferResult(null);
    setTransactionPin("");
  };

  const getSelectedWallet = () => {
    return wallets.find(
      (w) => w.wallet_number === selectedWallet || w.id === selectedWallet
    );
  };

  useEffect(() => {

    if (walletTransferMutation.error == undefined) return;

    console.log(walletTransferMutation.error);


  }, [walletTransferMutation.error])



  if (isWalletLoading)
    return <Preloader fullScreen={true} message="Loading payment options..." />;

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      {/* Modern Header */}
      <header className="bg-white border-b border-gray-200/60 shadow-sm backdrop-blur-sm">
        <div className="px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">

              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center shadow-lg">
                  <PaymentIcon className="text-white text-xl" />
                </div>
                <div>
                  <h1 className="text-xl sm:text-2xl font-bold text-gray-900">
                    Payment
                  </h1>
                  <p className="text-sm text-gray-600">
                    Make secure bank transfers
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="px-4 sm:px-6 py-6 sm:py-8">
        <div className="max-w-4xl">
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-12 md:col-span-6 lg:col-span-8">
              {!walletTransferMutation.isPending && walletTransferMutation.error && (
                <Alert severity="error" className="mb-6 shadow-sm">
                  {walletTransferMutation.error.response.data.message}
                </Alert>
              )}

              <Grid item xs={12} md={10} lg={8}>
                <Grid item xs={12} md={8} lg={6}>
                  <Card className="bg-white border border-gray-200/60 shadow-lg rounded-2xl overflow-hidden w-full">
                    <div className="bg-gradient-to-r from-blue-600 to-blue-700 px-6 py-4">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-3">
                          <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
                            <AccountBalanceIcon className="text-white text-xl" />
                          </div>
                          <div>
                            <Typography
                              variant="h5"
                              className="text-white font-bold"
                            >
                              Wallet Transfer
                            </Typography>
                            <Typography variant="body2" className="text-blue-100">
                              Send money to other wallet accounts
                            </Typography>
                          </div>
                        </div>

                      </div>
                    </div>

                    <CardContent className="p-6">
                      <div className="space-y-6">
                        {/* Source Wallet */}
                        <div>
                          <Typography
                            variant="subtitle2"
                            className="text-gray-700 font-semibold mb-2"
                          >
                            Source Wallet
                          </Typography>
                          <FormControl fullWidth>
                            <Select
                              value={selectedWallet}
                              onChange={handleChange}
                              className="bg-gray-50 border-gray-200"
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  borderRadius: "12px",
                                  "&:hover .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#3b82f6",
                                  },
                                },
                              }}
                            >
                              {wallets &&
                                wallets.map((wallet) => (
                                  <MenuItem
                                    key={wallet.id}
                                    value={wallet.wallet_number || wallet.id}
                                  >
                                    <div className="flex items-center gap-3 w-full">
                                      <Avatar className="w-8 h-8 bg-gradient-to-br from-blue-500 to-blue-600">
                                        <AccountBalanceWalletIcon className="text-white text-sm" />
                                      </Avatar>
                                      <div className="flex-1">
                                        <div className="font-medium text-gray-900">
                                          {wallet.currency?.code} Wallet
                                        </div>
                                        <div className="text-sm text-gray-500">
                                          Balance: {wallet.currency?.symbol}
                                          {parseFloat(
                                            wallet.balance || 0
                                          ).toLocaleString()}
                                        </div>
                                      </div>
                                    </div>
                                  </MenuItem>
                                ))}
                            </Select>
                          </FormControl>
                        </div>

                        {/* source_wallet_number
bank_id
amount
description
transaction_pin */}


                        <CustomInput
                          inputName={"destination_account_number"}
                          onChange={handleChange}
                          value={formData.destination_account_number}
                          label={"Account Number"}
                          inputType="number"
                        />
                        {accountName && (
                          <Chip
                            icon={<TaskAlt />}
                            label={`${accountName}`}
                            color="success"
                            variant="outlined"
                            className="rounded-xl"
                          />
                        )}

                        <CustomInput
                          inputName={"amount"}
                          onChange={handleChange}
                          value={formData.amount}
                          label={"Amount"}
                          inputType="number"
                        />

                        <CustomInput
                          inputName={"description"}
                          onChange={handleChange}
                          value={formData.description}
                          label={"Description"}
                        />

                        <CustomInput
                          inputName={"transaction_pin"}
                          onChange={handleChange}
                          value={formData.transaction_pin}
                          label={"Transaction Pin"}
                          inputType="number"
                        />

                        {/* Transfer Button */}

                        <CustomButton
                          onPress={handleProcessTransfer}
                          isLoading={walletTransferMutation.isPending}
                          label={"Continue to Transfer"}
                        />
                      </div>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </div>
          </div>
        </div>
      </main>

      {/* Transfer Confirmation Dialog */}
      <Dialog
        open={transferDialogOpen}
        onClose={handleCloseTransferDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          className: "rounded-2xl",
        }}
      >
        <DialogTitle className="flex items-center gap-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white">
          <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center">
            <SendIcon className="text-white" />
          </div>
          <div>
            <Typography variant="h6" className="text-white font-bold">
              Confirm Transfer
            </Typography>
            <Typography variant="body2" className="text-blue-100">
              Review your transfer details
            </Typography>
          </div>
        </DialogTitle>
        <DialogContent className="p-6">
          {transferStep === 1 && (
            <div className="space-y-4">
              <Alert severity="info" className="rounded-xl">
                Please review your transfer details before proceeding.
              </Alert>

              <div className="space-y-4">
                <div className="grid grid-cols-2 gap-4">
                  <div className="bg-gray-50 p-3 rounded-xl">
                    <Typography variant="caption" className="text-gray-500">
                      From
                    </Typography>
                    <Typography variant="body1" className="font-semibold">
                      {getSelectedWallet()?.currency?.code} Wallet
                    </Typography>
                  </div>
                  <div className="bg-gray-50 p-3 rounded-xl">
                    <Typography variant="caption" className="text-gray-500">
                      To
                    </Typography>
                    <Typography variant="body1" className="font-semibold">
                      {accountName}
                    </Typography>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div className="bg-gray-50 p-3 rounded-xl">
                    <Typography variant="caption" className="text-gray-500">
                      Account
                    </Typography>
                    <Typography variant="body1" className="font-semibold">
                      {accountNumber}
                    </Typography>
                  </div>
                </div>

                <Divider />

                <div className="space-y-3">
                  <div className="flex justify-between items-center">
                    <Typography variant="body1" className="text-gray-600">
                      Amount:
                    </Typography>
                    <Typography
                      variant="h5"
                      className="font-bold text-gray-900"
                    >
                      ₦
                      {parseFloat(
                        // @ts-ignore
                        amount || 0
                      ).toLocaleString()}
                    </Typography>
                  </div>
                  <div className="flex justify-between items-center">
                    <Typography variant="body1" className="text-gray-600">
                      Fee:
                    </Typography>
                    <Typography
                      variant="body1"
                      className="font-semibold text-gray-900"
                    >
                      ₦50.00
                    </Typography>
                  </div>
                  <div className="flex justify-between items-center bg-blue-50 p-3 rounded-xl">
                    <Typography
                      variant="body1"
                      className="text-blue-800 font-semibold"
                    >
                      Total:
                    </Typography>
                    <Typography
                      variant="h5"
                      className="font-bold text-blue-600"
                    >
                      ₦
                      {(
                        parseFloat(
                          // @ts-ignore
                          amount || 0
                        ) + 50
                      ).toLocaleString()}
                    </Typography>
                  </div>
                </div>

                <Divider />

                <div className="bg-gray-50 p-3 rounded-xl">
                  <Typography variant="caption" className="text-gray-500">
                    Description
                  </Typography>
                  <Typography variant="body1" className="font-medium">
                    {description}
                  </Typography>
                </div>
              </div>

              {transferError && (
                <Alert severity="error" className="rounded-xl">
                  {transferError}
                </Alert>
              )}
            </div>
          )}

          {transferStep === 2 && transferResult && (
            <div className="space-y-4">
              <Alert severity="success" className="rounded-xl">
                Transfer initiated successfully! Please enter your PIN to
                complete the transfer.
              </Alert>

              <div className="space-y-3">
                <div className="grid grid-cols-3 gap-3">
                  <div className="bg-green-50 p-3 rounded-xl text-center">
                    <Typography variant="caption" className="text-green-600">
                      Amount
                    </Typography>
                    <Typography
                      variant="body1"
                      className="font-semibold text-green-700"
                    >
                      ₦{transferResult.amount_processable}
                    </Typography>
                  </div>
                  <div className="bg-orange-50 p-3 rounded-xl text-center">
                    <Typography variant="caption" className="text-orange-600">
                      Fee
                    </Typography>
                    <Typography
                      variant="body1"
                      className="font-semibold text-orange-700"
                    >
                      ₦{transferResult.platform_charge_fee}
                    </Typography>
                  </div>
                  <div className="bg-blue-50 p-3 rounded-xl text-center">
                    <Typography variant="caption" className="text-blue-600">
                      Total
                    </Typography>
                    <Typography
                      variant="body1"
                      className="font-semibold text-blue-700"
                    >
                      ₦{transferResult.total_amount_processable}
                    </Typography>
                  </div>
                </div>
              </div>

              <div className="space-y-2">
                <Typography
                  variant="subtitle2"
                  className="text-gray-700 font-semibold"
                >
                  Transaction PIN
                </Typography>
                <TextField
                  fullWidth
                  type={showPin ? "text" : "password"}
                  value={transactionPin}
                  onChange={(e) => setTransactionPin(e.target.value)}
                  placeholder="Enter your 4-digit PIN"
                  inputProps={{ maxLength: 4 }}
                  className="bg-gray-50"
                  InputProps={{
                    endAdornment: (
                      <IconButton
                        onClick={() => setShowPin(!showPin)}
                        edge="end"
                        className="text-gray-500"
                      >
                        {showPin ? <VisibilityOffIcon /> : <VisibilityIcon />}
                      </IconButton>
                    ),
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "12px",
                    },
                  }}
                />
              </div>

              {transferError && (
                <Alert severity="error" className="rounded-xl">
                  {transferError}
                </Alert>
              )}
            </div>
          )}

          {transferStep === 3 && transferResult && (
            <div className="space-y-4">
              <Alert severity="success" className="rounded-xl">
                Transfer completed successfully!
              </Alert>

              <div className="space-y-3">
                <div className="bg-green-50 p-4 rounded-xl">
                  <div className="flex items-center gap-2 mb-3">
                    <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center">
                      <SendIcon className="text-white text-sm" />
                    </div>
                    <Typography
                      variant="h6"
                      className="text-green-800 font-bold"
                    >
                      Transfer Successful
                    </Typography>
                  </div>

                  <div className="space-y-2">
                    <div className="flex justify-between">
                      <span className="text-gray-600">Reference:</span>
                      <span className="font-medium text-gray-900">
                        {transferResult.data?.reference_number}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Status:</span>
                      <Chip
                        label={
                          transferResult.data?.status?.label || "Successful"
                        }
                        color="success"
                        size="small"
                        className="rounded-xl"
                      />
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Amount:</span>
                      <span className="font-semibold text-gray-900">
                        ₦{transferResult.data?.user_amount}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </DialogContent>
        <DialogActions className="p-6 pt-0">
          {transferStep === 1 && (
            <>
              <Button
                onClick={handleCloseTransferDialog}
                className="rounded-xl"
              >
                Cancel
              </Button>
              <Button
                onClick={handleInitiateTransfer}
                variant="contained"
                disabled={transferLoading}
                startIcon={
                  transferLoading ? (
                    <CircularProgress size={20} />
                  ) : (
                    <SendIcon />
                  )
                }
                className="bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 rounded-xl"
              >
                {transferLoading ? "Initiating..." : "Initiate Transfer"}
              </Button>
            </>
          )}

          {transferStep === 2 && (
            <>
              <Button
                onClick={handleCloseTransferDialog}
                className="rounded-xl"
              >
                Cancel
              </Button>
              <Button
                onClick={handleProcessTransfer}
                variant="contained"
                disabled={transferLoading || !transactionPin}
                startIcon={
                  transferLoading ? (
                    <CircularProgress size={20} />
                  ) : (
                    <SendIcon />
                  )
                }
                className="bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 rounded-xl"
              >
                {transferLoading ? "Processing..." : "Complete Transfer"}
              </Button>
            </>
          )}

          {transferStep === 3 && (
            <Button
              onClick={handleCloseTransferDialog}
              variant="contained"
              className="bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 rounded-xl"
            >
              Done
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}
